// extracted by mini-css-extract-plugin
export default {"image":"style_image__AB0pt","dottedLine":"style_dottedLine__NAvIS","fwbold":"style_fwbold__C2Li4","textmuted":"style_textmuted__5SW7o"};